export default __webpack_public_path__ + "static/media/zzz.fae916c7.svg";